import {
  pxTovW,
  pxToRem,
  IconWrapper,
  IStyles,
  theme,
  PrimaryButton,
  useCommonServiceClientContext,
  deserify,
  getDifficultyLevelString,
  InfoBar,
  ActionsPopup,
  Loader,
  calculateTotalTime,
  cloneObject,
} from '@geneo2-web/shared-ui';
import { Box, Divider, Typography, useMediaQuery } from '@mui/material';
import {
  useAppDispatch,
  useAppSelector,
} from '../../../../reduxStore/reduxHooks';
import { useEffect, useRef, useState } from 'react';
import {
  AssessmentContent,
  AssessmentTask,
} from '@protos/learning_management/lms.assessment.common.apis_pb';
import {
  ChapterIdsInfo,
  ChapterInfo,
  MultiSubjectSection,
  MultiSubjectSectionStatusEnum,
  MultiSubjectSubSection,
  QuestionModuleMap,
  TaskCreationStatusEnum,
  TaskEnum,
  TaskInfo,
  TaskMetaInfo,
} from '@protos/learning_management/lms.db_pb';
import { useLocation, useNavigate } from 'react-router-dom';
import {
  HOME,
  QPG_ASSESSMENT_CREATION,
  QPG_ASSESSMENT_PUBLISH,
} from '../../../../routeHandling/RoutesNomenclature';
import {
  DifficultyLevelEnum,
  Question,
} from '@protos/content_management/content.db_pb';
import { setToastInfoV2 } from '../../../Home/reducer/homeDashboard.slice';
import {
  setQPGContent,
  setQPGMultiSubjectInfoHash,
  setQPGSubsectionData,
} from '../../reducer/assessmentFlow.slice';
import {
  getBloomLevelData,
  getStringHash,
  questionCountTypeWise,
} from '../../QuestionPaperGenerator/ReviewQuestionPaper/utils';
import { ConnectError } from '@bufbuild/connect';
import { BloomLevelComponent } from '../../components/BloomLevelComponent';
import { InfoBarComponent } from '../../components/InfoBarComp';
import { ChapterTopicPopup } from '../../../../components/ChapterTopicPopup';
import { QPGReviewPaperSection } from './components/QPGReviewPaperSection';
import { useGlobalContext } from '../../../../app/Context/GlobalContextProvider';
import { ProfileRolesEnum } from '@protos/user_management/ums.db_pb';
import {
  SubSectionQuestionType,
  SubSectionTypeV2,
} from '@protos/learning_management/lms.assessment.teacher.apis_pb';
import {
  buildTaskInfoModels,
  formatMarksDisplay,
  getAllQuestionIdsFromMeta,
  getAttemptAnyMarksPerQuestion,
  getSubSectionMarksTotal,
  isPassageSectionEnabled,
  seedGroupedQuestionHeadingsOnSections,
} from '../../utils/QPGv2.utils';
import { SelectedChaptersV2 } from '../components/SelectedChaptersV2';
import { getChapterInfoFromSelectedSectionQuestions } from '../../FormativeAssessmentV2/FAv2.utils';

const styles: IStyles = {
  root: {
    paddingX: { xs: pxToRem(20), md: pxTovW(50), lg: pxTovW(240) },
    paddingY: { xs: pxToRem(20), md: pxTovW(50) },
    backgroundColor: '#f8f7fc',
    minHeight: '100vh',
  },
  primaryHeadingBox: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  mainContainer: {
    display: 'flex',
    flexDirection: { xs: 'column', md: 'row' },
    gap: { xs: pxToRem(20), md: pxTovW(40) },
    marginTop: { xs: pxToRem(20), md: pxTovW(40) },
  },
  leftPanel: {
    display: 'flex',
    flexDirection: 'column',
    gap: { xs: pxToRem(10), md: pxTovW(30) },
    flexBasis: { md: pxTovW(550), lg: pxTovW(415) },
  },
  bloomContainer: {
    border: '1px solid #E0E2E4',
    display: { xs: 'none', md: 'flex' },
    flexDirection: 'column',
    gap: { xs: pxToRem(11), md: pxTovW(20) },
    padding: {
      xs: pxToRem(10),
      md: `${pxTovW(15)} ${pxTovW(13)} ${pxTovW(15)} ${pxTovW(10)}`,
    },
    background: '#FFFFFF',
    boxShadow: `0px 0px ${pxToRem(5)} #E7E7E7D9`,
    borderRadius: { xs: pxToRem(10), md: pxTovW(15) },
  },
  paperDetailsBox: {
    display: 'flex',
    justifyContent: 'space-between',
    background: '#FFFFFF',
    boxShadow: `0px 0px ${pxToRem(5)} #E7E7E7D9`,
    borderRadius: { xs: pxToRem(10), md: pxTovW(15) },
    paddingX: { xs: pxToRem(10), md: pxTovW(20) },
    paddingY: { xs: pxToRem(10), md: pxTovW(25) },
  },
  detailsBox: {
    display: 'flex',
    alignItems: 'center',
    gap: { xs: pxToRem(5), md: pxTovW(5) },
  },
  mobileContainer: {
    display: { xs: 'flex', md: 'none' },
    border: '1px solid #007CDC4D',
    flexDirection: 'row',
    gap: { xs: pxToRem(5), md: pxTovW(5) },
    padding: { xs: pxToRem(10), md: pxTovW(15) },
    marginY: { xs: pxToRem(10), md: pxTovW(10) },
    // marginX: { xs: pxToRem(20) },
    background: '#FFFFFF',
    boxShadow: `0px 0px ${pxToRem(5)} #E7E7E7D9`,
    borderRadius: { xs: pxToRem(10), md: pxTovW(15) },
    justifyContent: 'space-between',
  },

  secondaryHeadingBox: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginY: { xs: pxToRem(20), md: pxTovW(40) },
  },
  previewAndPublishBox: {
    display: 'flex',
    alignItems: 'center',
    gap: { xs: pxToRem(10), md: pxTovW(30) },
  },
  addMoreBox: {
    background: '#C1F8DA',
    display: 'flex',
    borderRadius: { xs: pxToRem(6), md: pxTovW(10) },
    boxSizing: 'border-box',
    justifyContent: 'center',
    alignItems: 'center',
    border: '1px solid #0AA34F',
    padding: {
      xs: pxToRem(5),
      md: `${pxTovW(16)} ${pxTovW(23)}`,
      lg: `${pxTovW(13)} ${pxTovW(25)}`,
    },
    gap: { xs: pxToRem(5), md: pxTovW(16) },
    // height: { xs: pxToRem(32), md: pxTovW(57) },
  },
  addInstructionsBox: {
    background: '#CFEAFF',
    display: 'flex',
    borderRadius: { xs: pxToRem(6), md: pxTovW(10) },
    boxSizing: 'border-box',
    justifyContent: 'center',
    alignItems: 'center',
    border: '1px solid #007CDC',
    padding: {
      xs: pxToRem(5),
      md: `${pxTovW(16)} ${pxTovW(23)}`,
      lg: `${pxTovW(13)} ${pxTovW(25)}`,
    },
    gap: { xs: pxToRem(5), md: pxTovW(16) },
  },
  generalInstructionsBox: {
    display: 'flex',
    flexDirection: 'column',
    gap: { xs: pxToRem(10), md: pxTovW(10) },
    backgroundColor: '#ffffff',
    border: '1px solid #E0E2E4',
    borderRadius: { xs: pxToRem(15), md: pxTovW(15) },
    paddingX: { xs: pxToRem(20), md: pxTovW(20) },
    paddingY: { xs: pxToRem(16), md: pxTovW(16) },
    marginTop: { xs: pxToRem(20), md: pxTovW(25) },
    marginBottom: { xs: pxToRem(30), md: pxTovW(70) },
  },
  subjectDataBox: {
    display: 'flex',
    flexDirection: 'column',
    gap: { xs: pxToRem(10), md: pxTovW(40) },
  },
  subjectSectionDetails: {
    backgroundColor: '#ffffff',
    borderRadius: { xs: pxToRem(15), md: pxTovW(15) },
    border: '1px solid #E0E2E4',
    paddingX: { xs: pxToRem(20), md: pxTovW(20) },
    paddingY: { xs: pxToRem(16), md: pxTovW(16) },
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  instructionText: {
    fontFamily: 'Poppins',
    marginTop: { xs: pxToRem(15), md: pxTovW(15) },
    marginBottom: { xs: pxToRem(40), md: pxTovW(40) },
    fontSize: { xs: pxToRem(12), md: 'unset' },
  },
};

export const QPGReviewPaper = () => {
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const isIpad = useMediaQuery(theme.breakpoints.down('lg'));
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const { setSelectedFunction, setSelectedLogoClickHandler } =
    useGlobalContext();

  const {
    LmsAssessmentTeacherAPIServiceV6WithStatusCodeHandler,
    LmsAssessmentCommonAPIServiceV1ClientWithStatusCodeHandler,
  } = useCommonServiceClientContext();
  const { user_info } = deserify(useAppSelector((state) => state.auth));
  const {
    qpg_content,
    qpg_selected_section_index,
    qpg_selected_section_number,
    qpg_multi_subject_info_hash,
    qpg_subsection_data,
  } = deserify(useAppSelector((state) => state.assessment));

  const qpgAssessmentTask = new AssessmentTask(qpg_content?.assessment);
  const taskCreationStatus = qpgAssessmentTask.taskCreationStatus;
  const testLevelInstructions = qpgAssessmentTask.assessmentInstructions || [];

  const [loading, setLoading] = useState<'loading' | 'success' | 'error'>(
    'success'
  );
  const [bloomPopup, setBloomPopup] = useState(false);
  const [chaptersPopup, setChaptersPopup] = useState(false);
  const [assessmentCreationFlow, setAssessmentCreationFlow] = useState<
    'chapter' | 'bloom' | 'ques-type' | undefined
  >(undefined);
  const [isPaperInitialised, setIsPaperInitialised] = useState(
    !!location.state?.isFromQuestionBank
  );
  const [exitConfirmPopup, setExitConfirmPopup] = useState<
    'back' | 'home' | undefined
  >(undefined);

  const [updatingAssessment, setUpdatingAssessment] = useState(false);
  const isSavingFromEditFlowRef = useRef(false);
  /** When true, heading-only Redux updates skip the autosave effect (Save button calls handleSave). */
  const skipAutosaveForHeadingRef = useRef(false);

  const assessmentQuestionIds =
    qpg_content?.multiSubjectSections[
      qpg_selected_section_index ?? 0
    ]?.multiSubjectSubSections?.flatMap((subSection) =>
      (subSection.subSectionMetaData ?? []).flatMap((meta) =>
        getAllQuestionIdsFromMeta(meta)
      )
    ) ?? [];

  const isAssessmentChanged =
    typeof qpg_selected_section_index == 'number' &&
    qpg_multi_subject_info_hash !==
      generateHashString(
        qpg_content?.multiSubjectSections[qpg_selected_section_index]
      );

  const qpgAssessmentQuestions = (
    qpg_content?.assessmentContent?.map((ques) => new Question(ques)) || []
  ).filter((ques) => assessmentQuestionIds.includes(ques.questionId ?? ''));

  const taskMetaInfo = qpg_content?.assessment?.taskMetaInfo;
  const selectedSection = qpg_content?.multiSubjectSections?.find(
    (section) => section.sectionNo === qpg_selected_section_number
  );
  const hideQuestionCounts =
    selectedSection?.multiSubjectSubSections?.some(isPassageSectionEnabled) ??
    false;
  const sectionChapterInfo =
    qpg_content?.multiSubjectSections?.[qpg_selected_section_index ?? 0]
      ?.chapterInfo;
  const filteredTaskMetaInfo = (() => {
    if (
      !taskMetaInfo?.chapterInfo?.chapterTopicsInfo?.length ||
      !sectionChapterInfo?.chapterTopicsInfo?.length
    ) {
      return taskMetaInfo;
    }
    const sectionChapters = sectionChapterInfo.chapterTopicsInfo;
    const allowedChapterIds = new Set(sectionChapters.map((c) => c.chapterId));
    const allowedTopicIdsByChapter = new Map<number, Set<number>>();
    for (const ch of sectionChapters) {
      const topicIds = new Set((ch.topicInfo ?? []).map((t) => t.topicId));
      allowedTopicIdsByChapter.set(ch.chapterId, topicIds);
    }
    const filteredChapterTopicsInfo = taskMetaInfo
      .chapterInfo!.chapterTopicsInfo.filter((ch) =>
        allowedChapterIds.has(ch.chapterId)
      )
      .map(
        (ch) =>
          new ChapterIdsInfo({
            chapterId: ch.chapterId,
            name: ch.name,
            chapterNo: ch.chapterNo,
            noOfQuestions: ch.noOfQuestions,
            subjectId: ch.subjectId,
            topicInfo: (ch.topicInfo ?? []).filter((t) =>
              allowedTopicIdsByChapter.get(ch.chapterId)?.has(t.topicId)
            ),
          })
      );
    return new TaskMetaInfo({
      chapterInfo: new ChapterInfo({
        chapterTopicsInfo: filteredChapterTopicsInfo,
      }),
    });
  })();

  const questionModuleMap =
    qpg_content?.questionsSequenceInfo?.questionModuleMap || [];

  const filteredQuestionModuleMap = assessmentQuestionIds.map((qId) => {
    return (
      questionModuleMap.find((val) => val.questionId === qId) ||
      new QuestionModuleMap({
        questionId: qId,
      })
    );
  });

  const qpgQuestionTypeMarks = qpg_content?.questionTypeAndMarks || [];
  const totalTimeInMinutes = calculateTotalTime(qpgAssessmentQuestions || []);

  // --------------------------------------------------------------

  const getMarksForQuestionId = (questionId: string): number => {
    const ques = qpgAssessmentQuestions.find((q) => q.questionId == questionId);
    const taskInfo = qpg_content?.questionsSequenceInfo?.taskQuestionInfo?.find(
      (info) => info.questionId == questionId
    );
    const quesType = ques?.questionType;
    const foundQuesType = qpgQuestionTypeMarks.find(
      (qType) => qType.questionType == quesType
    );
    if (foundQuesType) return foundQuesType.marks ?? 0;
    if (typeof taskInfo?.maxMarks === 'number') return taskInfo.maxMarks;
    const existing =
      ques?.question?.model?.value?.commonQuestionContent?.marks?.[0];
    if (typeof existing === 'number') return existing;
    return 0;
  };

  // --------------------------------------------------------------

  const sectionToShow =
    qpg_content?.multiSubjectSections?.[qpg_selected_section_index ?? 0] ??
    qpg_content?.multiSubjectSections?.[0];

  const selectedSectionTotalQuestions =
    sectionToShow?.multiSubjectSubSections?.reduce(
      (sum, subSection) => sum + (subSection.subSectionMetaData?.length ?? 0),
      0
    ) ?? 0;

  const hasEmptySubsection =
    qpg_content?.multiSubjectSections?.some((section) =>
      section.multiSubjectSubSections?.some(
        (subSection) => (subSection.subSectionMetaData?.length ?? 0) === 0
      )
    ) ?? true;

  const selectedSectionTotalMarks =
    sectionToShow?.multiSubjectSubSections?.reduce(
      (sectionSum, subSection) =>
        sectionSum +
        getSubSectionMarksTotal({
          subSection,
          getMarksForQuestionId,
        }),
      0
    ) ?? 0;

  // --------------------------------------------------------------

  const fetchAssessmentContent = async () => {
    try {
      setLoading('loading');
      const fetchAssessmentContentResponse =
        await LmsAssessmentCommonAPIServiceV1ClientWithStatusCodeHandler.fetchAssessmentContent(
          {
            personId: user_info?.teacherProfileId,
            personType: ProfileRolesEnum.PROFILE_ROLE_TEACHER,
            assessmentId: qpg_content?.assessment?.assessmentId,
          }
        );

      if (fetchAssessmentContentResponse.data) {
        setLoading('success');

        dispatch(setQPGContent(fetchAssessmentContentResponse.data));
        dispatch(
          setQPGMultiSubjectInfoHash(
            generateHashString(
              fetchAssessmentContentResponse.data?.multiSubjectSections[
                qpg_selected_section_index ?? 0
              ]
            )
          )
        );
        setIsPaperInitialised(true);
      } else {
        setLoading('error');
      }
    } catch (error) {
      console.log(error);
      setLoading('error');
    }
  };

  // --------------------------------------------------------------

  const handleCreateAssessment = async () => {
    await handleSave({ createAssessment: true });
  };

  // --------------------------------------------------------------

  // const bloomLevelData = getBloomLevelData(
  //   questionsListWithoutAlternateQuestions
  // );
  const bloomLevelData = getBloomLevelData(qpgAssessmentQuestions);

  // --------------------------------------------------------------

  interface IDifficultyLevelBreakdown {
    easy: {
      difficultyLevel: DifficultyLevelEnum.DIFFICULTY_LEVEL_LOW;
      count: number;
    };
    medium: {
      difficultyLevel: DifficultyLevelEnum.DIFFICULTY_LEVEL_MEDIUM;
      count: number;
    };
    hard: {
      difficultyLevel: DifficultyLevelEnum.DIFFICULTY_LEVEL_HIGH;
      count: number;
    };
  }

  const getDifficultyLevelBreakdown = (
    questionModuleMap: QuestionModuleMap[]
  ) => {
    const difficultyLevelBreakdown: IDifficultyLevelBreakdown = {
      easy: {
        difficultyLevel: DifficultyLevelEnum.DIFFICULTY_LEVEL_LOW,
        count: 0,
      },
      medium: {
        difficultyLevel: DifficultyLevelEnum.DIFFICULTY_LEVEL_MEDIUM,
        count: 0,
      },
      hard: {
        difficultyLevel: DifficultyLevelEnum.DIFFICULTY_LEVEL_HIGH,
        count: 0,
      },
    };
    filteredQuestionModuleMap.forEach((questionModule) => {
      const difficultyLevel = questionModule.difficultyLevel;
      switch (difficultyLevel) {
        case DifficultyLevelEnum.DIFFICULTY_LEVEL_LOW:
          ++difficultyLevelBreakdown.easy.count;
          break;
        case DifficultyLevelEnum.DIFFICULTY_LEVEL_MEDIUM:
          ++difficultyLevelBreakdown.medium.count;
          break;
        case DifficultyLevelEnum.DIFFICULTY_LEVEL_HIGH:
          ++difficultyLevelBreakdown.hard.count;
          break;
        default:
          break;
      }
    });
    return difficultyLevelBreakdown;
  };

  // --------------------------------------------------------------

  const infoBarContentList = [
    {
      iconName: 'questions',
      // heading: totalQuestionsCount,
      heading: qpgAssessmentQuestions?.length || 0,
      subHeading: 'Questions',
    },
    {
      iconName: 'clock',
      heading: `${totalTimeInMinutes}`,
      subHeading: 'Minutes',
    },
    {
      iconName: 'level',
      // heading: `${getDifficultyLevelString(qpgAssessmentTask.difficultyLevel)}`,
      heading: `${getDifficultyLevelString(
        qpg_content?.multiSubjectSections?.[qpg_selected_section_index ?? 0]
          ?.avgDifficultyLevel
      )}`,
      subHeading: 'Difficulty Level',
    },
  ];

  // --------------------------------------------------------------

  const getDifficultyLevelstats = () => {
    // const breakdown = getDifficultyLevelBreakdown(
    //   qpg_question_module_map || []
    // );
    const breakdown = getDifficultyLevelBreakdown(filteredQuestionModuleMap);
    return [
      {
        iconName: 'stat-green',
        heading: breakdown.easy.count,
        headingSubText: 'Qs',
        subHeading: 'Easy',
      },
      {
        iconName: 'stat-yellow',
        heading: breakdown.medium.count,
        headingSubText: 'Qs',
        subHeading: 'Medium',
      },
      {
        iconName: 'stat-red',
        heading: breakdown.hard.count,
        headingSubText: 'Qs',
        subHeading: 'Hard',
      },
    ];
  };

  // --------------------------------------------------------------

  const handleSave = async (props: {
    createAssessment?: boolean;
    editAssessmentCreationFlow?: 'chapter' | 'bloom' | 'ques-type';
    /** Use when Redux has not re-rendered yet after a local content update. */
    contentOverride?: AssessmentContent;
  }) => {
    const { createAssessment, editAssessmentCreationFlow, contentOverride } =
      props;
    try {
      setUpdatingAssessment(true);

      // Persist default displayed group headings so they are included in submit.
      let contentForSave = contentOverride ?? qpg_content;
      if (contentForSave?.multiSubjectSections?.length) {
        const { sections, changed } = seedGroupedQuestionHeadingsOnSections(
          contentForSave.multiSubjectSections
        );
        if (changed) {
          const seededContent = cloneObject(contentForSave);
          seededContent.multiSubjectSections = sections;
          dispatch(setQPGContent(seededContent));
          contentForSave = seededContent;

          if (qpg_subsection_data?.length) {
            const selectedSection = sections.find(
              (section) => section.sectionNo === qpg_selected_section_number
            );
            const updatedSubSectionData = qpg_subsection_data.map(
              (sub, subIdx) => {
                const metaList =
                  selectedSection?.multiSubjectSubSections?.[subIdx]
                    ?.subSectionMetaData ?? [];
                return new SubSectionTypeV2({
                  ...sub,
                  subSectionQuestions: sub.subSectionQuestions.map((q, qi) => {
                    const heading = metaList[qi]?.groupQuestionHeading;
                    if (!q.isGrouped || !heading?.trim()) return q;
                    if (q.groupQuestionHeading?.trim()) return q;
                    return new SubSectionQuestionType({
                      ...q,
                      groupQuestionHeading: heading,
                    });
                  }),
                });
              }
            );
            dispatch(setQPGSubsectionData(updatedSubSectionData));
          }
        }
      }

      const multiSubjectSectionMetaInfo =
        contentForSave?.multiSubjectSections?.find(
          (section) => section.sectionNo === qpg_selected_section_number
        );

      const chapterInfoForCreateAssessment =
        getChapterInfoFromSelectedSectionQuestions({
          section: multiSubjectSectionMetaInfo,
          questionModuleMap,
          chapterTopicsInfo: taskMetaInfo?.chapterInfo?.chapterTopicsInfo ?? [],
        });

      const metaInfo: MultiSubjectSection[] =
        contentForSave?.multiSubjectSections?.map(
          (section: MultiSubjectSection) => {
            const isSelectedSection =
              section.sectionNo === qpg_selected_section_number;

            if (!isSelectedSection) return section;

            const sectionPayload =
              editAssessmentCreationFlow && multiSubjectSectionMetaInfo
                ? {
                    ...multiSubjectSectionMetaInfo,
                    multiSubjectSectionStatus:
                      MultiSubjectSectionStatusEnum.MULTI_SUBJECT_SECTION_STATUS_INITIALIZED,
                    multiSubjectSubSections: (
                      multiSubjectSectionMetaInfo.multiSubjectSubSections ?? []
                    ).map(
                      (subSection) =>
                        new MultiSubjectSubSection({
                          ...subSection,
                          subSectionMetaData: [],
                        })
                    ),
                  }
                : {
                    ...multiSubjectSectionMetaInfo,
                    multiSubjectSectionStatus: editAssessmentCreationFlow
                      ? MultiSubjectSectionStatusEnum.MULTI_SUBJECT_SECTION_STATUS_INITIALIZED
                      : createAssessment
                      ? MultiSubjectSectionStatusEnum.MULTI_SUBJECT_SECTION_STATUS_APPROVED
                      : section.multiSubjectSectionStatus ??
                        MultiSubjectSectionStatusEnum.MULTI_SUBJECT_SECTION_STATUS_DRAFT,
                    chapterInfo: chapterInfoForCreateAssessment,
                  };

            return new MultiSubjectSection(sectionPayload);
          }
        ) ?? [];
      // : contentForSave?.multiSubjectSections || [];

      const assessmentCreationSubmitResponse =
        await LmsAssessmentTeacherAPIServiceV6WithStatusCodeHandler.assessmentCreationSubmit(
          {
            teacherId: user_info?.teacherProfileId,
            assessmentId: contentForSave?.assessment?.assessmentId,
            classId: contentForSave?.assessment?.classId,
            creationStatus: TaskCreationStatusEnum.TASK_CREATION_STATUS_DRAFT,
            multiSubjectSectionMetaInfo: metaInfo,
            sectionId: contentForSave?.assessment?.sectionId,
            subjectIds:
              contentForSave?.multiSubjectSections.map(
                (section) => section.subjectId
              ) ?? [],
            taskName: contentForSave?.assessment?.assessmentTitle,
            taskType: TaskEnum.TASK_MULTI_SUBJECT_QUESTION_PAPER_CUSTOM,
            instructions: contentForSave?.assessment?.assessmentInstructions,
            questionModuleMap:
              contentForSave?.questionsSequenceInfo?.questionModuleMap,
            selectedTasksInfo: buildTaskInfoModels(metaInfo),
            chapterIdsInfo: taskMetaInfo?.chapterInfo?.chapterTopicsInfo,
          }
        );

      if (assessmentCreationSubmitResponse.status === 200) {
        if (createAssessment) {
          navigate(
            `${QPG_ASSESSMENT_PUBLISH}?assessment_id=${assessmentCreationSubmitResponse.data?.assessment?.assessmentId}`
          );
          return;
        } else if (editAssessmentCreationFlow) {
          navigate(
            QPG_ASSESSMENT_CREATION + `?edit_flow=${editAssessmentCreationFlow}`
          );
        }
      }
      await fetchAssessmentContent();
      dispatch(
        setQPGMultiSubjectInfoHash(
          generateHashString(metaInfo[qpg_selected_section_index ?? 0])
        )
      );
    } catch (error) {
      console.error('Error saving question paper:', error);
      dispatch(
        setToastInfoV2({
          label:
            error instanceof ConnectError
              ? error.rawMessage?.replace(/.*\]\s*/, '').trim()
              : 'Error while saving assessment',
          variant: 'error',
          open: true,
        })
      );
    } finally {
      setUpdatingAssessment(false);
      // if (shouldPublish) {
      //   setBloomPopup(false);
      //   setChaptersPopup(false);
      // }
    }
  };

  // --------------------------------------------------------------

  const renderQuestionTypeList = () => {
    return Object.keys(
      // questionCountTypeWise(questionsListWithoutAlternateQuestions)
      questionCountTypeWise(qpgAssessmentQuestions)
    ).map((val, index) => (
      <Box
        key={index}
        sx={{
          display: 'flex',
          gap: { xs: pxToRem(5), md: pxTovW(5) },
        }}
      >
        <IconWrapper
          name="question-blue"
          type="png"
          parentFolder="icons"
          size="md"
        />
        <Typography variant="h5">{val}</Typography>
      </Box>
    ));
  };

  // --------------------------------------------------------------

  useEffect(() => {
    if (isSavingFromEditFlowRef.current) return;
    if (skipAutosaveForHeadingRef.current) {
      skipAutosaveForHeadingRef.current = false;
      return;
    }
    if (
      isPaperInitialised &&
      isAssessmentChanged &&
      qpg_multi_subject_info_hash !== undefined
    ) {
      // Update the assessment with the new changes
      handleSave({});
    }
  }, [isAssessmentChanged]);

  const backButtonClick = () => {
    setExitConfirmPopup('back');
  };
  const handleLogoClick = () => {
    setExitConfirmPopup('home');
  };

  useEffect(() => {
    setSelectedFunction(() => backButtonClick);
    setSelectedLogoClickHandler(() => handleLogoClick);
    return () => {
      setSelectedFunction(null);
      setSelectedLogoClickHandler(null);
    };
  }, [exitConfirmPopup]);

  useEffect(() => {
    if (!location.state?.isFromQuestionBank) {
      fetchAssessmentContent();
    } else {
      navigate(location.pathname, {
        replace: true,
        state: {
          isFromQuestionBank: false,
          redirectionPath: location.state?.redirectionPath,
        },
      });
    }
  }, []);

  // --------------------------------------------------------------

  if (loading === 'loading') return <Loader />;

  return (
    <Box sx={styles.root}>
      <Box sx={styles.primaryHeadingBox}>
        <Typography variant="h1">Question Paper Generator</Typography>

        <PrimaryButton
          onClick={handleCreateAssessment}
          disabled={hasEmptySubsection}
          sx={{ width: 'max-content' }}
        >
          <Typography variant="h3" fontWeight="bold" color="common.white">
            CREATE ASSESSMENT
          </Typography>
        </PrimaryButton>
      </Box>

      <Box sx={styles.mainContainer}>
        {/* LEFT PANEL */}
        <Box sx={styles.leftPanel}>
          <Box>
            <Box sx={{ width: '100%', display: { xs: 'none', md: 'flex' } }}>
              <SelectedChaptersV2
                assessmentTaskInfo={filteredTaskMetaInfo}
                questionModuleMap={filteredQuestionModuleMap}
                currentSectionChapterInfo={selectedSection?.chapterInfo}
                hideQuestionCounts={hideQuestionCounts}
                editClickHandler={() => {
                  setAssessmentCreationFlow('chapter');
                }}
              />
            </Box>

            <Box sx={styles.mobileContainer}>
              <Typography
                variant={isMobile ? 'h2' : 'h3'}
                fontWeight="bold"
                fontFamily="poppins"
              >
                What's Covered
              </Typography>
              <IconWrapper
                name="view"
                type="png"
                parentFolder="icons"
                size="md"
                customSx={{
                  height: { xs: pxToRem(20) },
                  width: { xs: pxToRem(20) },
                  cursor: 'pointer',
                }}
                onClick={() => setChaptersPopup(true)}
              />
            </Box>

            <Box sx={styles.mobileContainer}>
              <Typography
                variant={isMobile ? 'h2' : 'h3'}
                fontWeight="bold"
                fontFamily="poppins"
              >
                Bloom Level & Question Type
              </Typography>
              <Box
                sx={{
                  display: { xs: 'flex', md: 'none' },
                  gap: { xs: pxToRem(10) },
                }}
              >
                <IconWrapper
                  name="view"
                  type="png"
                  parentFolder="icons"
                  size="large"
                  customSx={{
                    height: { xs: pxToRem(20) },
                    width: { xs: pxToRem(20) },
                    cursor: 'pointer',
                  }}
                  onClick={() => {
                    setBloomPopup(true);
                  }}
                />
              </Box>
            </Box>
          </Box>

          <Box sx={styles.bloomContainer}>
            <Box>
              <BloomLevelComponent
                bloomLevelData={bloomLevelData}
                editClickHandler={() => {
                  setAssessmentCreationFlow('bloom');
                }}
              />
            </Box>
            <Divider sx={{ bgcolor: '#E0E0E0', height: '1px', opacity: 0.5 }} />
            <Box sx={{ display: { xs: 'none', md: 'block' } }}>
              <InfoBarComponent contentList={infoBarContentList} />
            </Box>
            <Divider sx={{ bgcolor: '#E0E0E0', height: '1px', opacity: 0.5 }} />
            <Box sx={{ display: { xs: 'none', md: 'block' } }}>
              <Typography
                variant="h3"
                fontWeight={600}
                fontFamily={'poppins'}
                marginBottom={pxToRem(10)}
              >
                Breakdown of Difficulty Level
              </Typography>
              <InfoBarComponent contentList={getDifficultyLevelstats()} />
            </Box>
            <Divider sx={{ bgcolor: '#E0E0E0', height: '1px', opacity: 0.5 }} />
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column',
                gap: { md: pxTovW(20) },
              }}
            >
              <Typography variant="h4" fontWeight={600} fontFamily={'poppins'}>
                Question Type
              </Typography>
              <Box
                sx={{
                  display: 'flex',
                  flexWrap: 'wrap',
                  gap: { xs: pxToRem(20) },
                }}
              >
                {renderQuestionTypeList()}
              </Box>
            </Box>
          </Box>

          <Box sx={styles.paperDetailsBox}>
            <Box sx={styles.detailsBox}>
              <IconWrapper
                name="questions"
                size="md"
                type="png"
                parentFolder="icons"
              />
              <Typography variant="h4">
                No. of Questions:
                <b> {selectedSectionTotalQuestions ?? 0}</b>
              </Typography>
            </Box>

            <Divider
              orientation="vertical"
              sx={{ width: '1px', height: '100%', backgroundColor: '#E0DFDE' }}
            />

            <Box sx={styles.detailsBox}>
              <IconWrapper
                name="percentage-primary"
                size="md"
                type="png"
                parentFolder="icons"
              />
              <Typography variant="h4">
                Total Marks:
                <b>
                  {' '}
                  {formatMarksDisplay(selectedSectionTotalMarks ?? 0)}
                </b>
              </Typography>
            </Box>
          </Box>
        </Box>

        {/* RIGHT PANEL */}
        <Box sx={styles.rightPanel}>
          <Box sx={styles.secondaryHeadingBox}>
            <Typography variant="h2">Review Question Paper</Typography>

            {/* <Box sx={styles.previewAndPublishBox}>
              <Button sx={styles.addMoreBox} onClick={viewLibraryHandler}>
                <AddCircleOutlineIcon
                  sx={{
                    color: '#0AA34F',
                    fontSize: { xs: pxToRem(18), md: pxTovW(30) },
                  }}
                />
                <Typography
                  variant="h3"
                  fontWeight="bold"
                  color="secondary.main"
                >
                  View Library
                </Typography>
              </Button>

              <Button
                sx={styles.addInstructionsBox}
                onClick={downloadPDFHandler}
              >
                <IconWrapper
                  name="download-qpg-blue"
                  type="png"
                  parentFolder="icons"
                  size="md"
                />
                {isMobile ? null : (
                  <Typography
                    variant="h3"
                    fontWeight="bold"
                    color="primary.main"
                  >
                    Download PDF
                  </Typography>
                )}
              </Button>
            </Box> */}
          </Box>

          {qpg_content?.multiSubjectSections.find(
            (section) => section.sectionNo === qpg_selected_section_number
          )?.isAiGenerated && (
            <Typography variant="h5" sx={{ fontFamily: 'Poppins' }}>
              <b>Note:</b> AI-generated questions may sometimes be inaccurate
              due to hallucinations. Please review and verify all questions
              before publishing to ensure accuracy.
            </Typography>
          )}

          {/* <Box sx={styles.generalInstructionsBox}>
            <Typography variant="h3" fontWeight="bold" color="primary.main">
              Question Paper Generator
            </Typography>
            {generalInstructions.map((instruction, index) => (
              <Typography variant="h4" key={index}>
                {index + 1}. {instruction}
              </Typography>
            ))}
          </Box> */}

          {/* <Box sx={styles.subjectDataBox}>
            {SUBJECT_DATA.map((subject, index) => (
              <Box key={index} sx={styles.subjectSectionDetails}>
                <Typography variant="h2" color="primary.main">
                  Section {index + 1} - {subject.subject}
                </Typography>

                <Typography variant="cardText" sx={styles.instructionText}>
                  {subject.instruction}
                </Typography>

                <QPGReviewPaperSubSection subject={subject} index={index} />
              </Box>
            ))}
          </Box> */}

          <QPGReviewPaperSection
            setUpdatingAssessment={setUpdatingAssessment}
            handleSave={handleSave}
            skipAutosaveForHeadingRef={skipAutosaveForHeadingRef}
          />
        </Box>
      </Box>

      <ChapterTopicPopup
        open={chaptersPopup}
        handleClose={() => {
          setChaptersPopup(false);
        }}
        popupBody={
          <SelectedChaptersV2
            assessmentTaskInfo={filteredTaskMetaInfo}
            questionModuleMap={filteredQuestionModuleMap}
            currentSectionChapterInfo={selectedSection?.chapterInfo}
            hideQuestionCounts={hideQuestionCounts}
            editClickHandler={() => {
              setAssessmentCreationFlow('chapter');
            }}
          />
        }
      />

      <ChapterTopicPopup
        open={bloomPopup}
        handleClose={() => {
          setBloomPopup(false);
        }}
        popupBody={
          <Box
            sx={{
              ...styles.bloomContainer,
              display: { xs: 'flex', md: 'none' },
            }}
          >
            <Box>
              <BloomLevelComponent
                bloomLevelData={bloomLevelData}
                editClickHandler={() => {
                  setAssessmentCreationFlow('bloom');
                }}
              />
            </Box>
            <Box>
              <InfoBar contentList={infoBarContentList} />
            </Box>
            <Box>
              <Typography
                variant="h3"
                fontWeight={600}
                fontFamily={'poppins'}
                marginBottom={pxToRem(10)}
              >
                Breakdown of Difficulty Level
              </Typography>
              <InfoBar contentList={getDifficultyLevelstats()} />
            </Box>

            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column',
                marginY: { xs: pxToRem(10) },
                gap: { xs: pxToRem(10) },
              }}
            >
              <Typography variant="h3" fontWeight={600} fontFamily={'poppins'}>
                Question Type
              </Typography>
              <Box
                sx={{
                  display: 'flex',
                  flexWrap: 'wrap',
                  gap: { xs: pxToRem(12) },
                }}
              >
                {renderQuestionTypeList()}
              </Box>
            </Box>
          </Box>
        }
      />

      <ActionsPopup
        open={!!assessmentCreationFlow}
        handleClose={() => {
          setAssessmentCreationFlow(undefined);
        }}
        fontSmall
        iconName="error_yellow"
        popupText="On editing this, Questions list will be reset."
        splitText="Are you sure?"
        yesClickHandler={async () => {
          // Set subsection data from qpg_content (selected section) for creation flow
          const section =
            qpg_content?.multiSubjectSections?.[
              qpg_selected_section_index ?? 0
            ];
          if (section?.multiSubjectSubSections?.length) {
            const subsectionDataFromContent = (
              section.multiSubjectSubSections ?? []
            ).map((sub, subIdx) => {
              const attemptAnyEnabled = sub.attemptAnyCount !== undefined;
              // Attempt-any UI stores group total on the row; content stores
              // per-child marks for grouped rows — restore the attemptable unit.
              const attemptAnyMarksPerQuestion = attemptAnyEnabled
                ? getAttemptAnyMarksPerQuestion({ subSection: sub })
                : undefined;

              return new SubSectionTypeV2({
                subSectionName: sub.subSectionName ?? '',
                sectionNumber: sub.subSectionNo ?? subIdx + 1,
                passageText: sub.passageText ?? [],
                passageImagesUpload: sub.passageImagesUpload ?? [],
                ...(sub.isAiGeneratedPassage !== undefined
                  ? { isAiGeneratedPassage: sub.isAiGeneratedPassage }
                  : {}),
                ...(attemptAnyEnabled
                  ? { attemptAnyCount: sub.attemptAnyCount }
                  : {}),
                ...(sub.subSectionType !== undefined
                  ? { subSectionType: sub.subSectionType }
                  : {}),
                subSectionQuestions: (sub.questionTypeAndMarks ?? []).map(
                  (qtm) =>
                    new SubSectionQuestionType({
                      questionType: qtm.questionType,
                      marks: attemptAnyMarksPerQuestion ?? qtm.marks ?? 0,
                      noOfQuestion: 0,
                      isAlternateEnable: false,
                    })
                ),
              });
            });
            dispatch(setQPGSubsectionData(subsectionDataFromContent));
          }

          // //  Clear subsection data of the selected section in local state
          // if (qpg_content?.multiSubjectSections && assessmentCreationFlow) {
          //   const sectionIndex = qpg_selected_section_index ?? 0;
          //   const section = qpg_content.multiSubjectSections[sectionIndex];
          //   if (section) {
          //     const updatedSections = qpg_content.multiSubjectSections.map(
          //       (sec, idx) => {
          //         if (idx !== sectionIndex) return sec;
          //         return new MultiSubjectSection({
          //           ...section,
          //           multiSubjectSectionStatus:
          //             MultiSubjectSectionStatusEnum.MULTI_SUBJECT_SECTION_STATUS_INITIALIZED,
          //           multiSubjectSubSections: (
          //             section.multiSubjectSubSections ?? []
          //           ).map(
          //             (subSection) =>
          //               new MultiSubjectSubSection({
          //                 ...subSection,
          //                 subSectionMetaData: [],
          //               })
          //           ),
          //         });
          //       }
          //     );
          //     const updatedContent = cloneObject(qpg_content);
          //     updatedContent.multiSubjectSections = updatedSections;
          //     dispatch(setQPGContent(updatedContent));
          //     dispatch(
          //       setQPGMultiSubjectInfoHash(
          //         generateHashString(updatedSections[sectionIndex])
          //       )
          //     );
          //   }
          // }

          isSavingFromEditFlowRef.current = true;
          await handleSave({
            editAssessmentCreationFlow: assessmentCreationFlow,
          });
          isSavingFromEditFlowRef.current = false;
          setAssessmentCreationFlow(undefined);
        }}
        noClickHandler={async () => {
          setAssessmentCreationFlow(undefined);
        }}
      />

      <ActionsPopup
        open={!!exitConfirmPopup}
        handleClose={() => {
          setExitConfirmPopup(undefined);
        }}
        fontSmall
        iconName="error_yellow"
        popupText="Your changes will be saved as draft"
        splitText="Are you sure you want leave?"
        yesClickHandler={async () => {
          if (exitConfirmPopup === 'back') {
            navigate(
              QPG_ASSESSMENT_PUBLISH +
                `?assessment_id=${qpg_content?.assessment?.assessmentId}`
            );
          } else {
            navigate(HOME);
          }
          setExitConfirmPopup(undefined);
        }}
        noClickHandler={async () => {
          setExitConfirmPopup(undefined);
        }}
      />
    </Box>
  );
};

// =====================================================

const generateHashString = (multiSubjectSectionInfo?: MultiSubjectSection) => {
  return getStringHash(
    new MultiSubjectSection(multiSubjectSectionInfo).toJsonString()
  );
};
